import {
  PAYROLL_ALL,
  PAYROLL_GET,
  PAYROLL_DELETE,
  PAYROLL_PUT,
  PAYROLL_POST,
  PAYROLL_LOADING,
  PAYROLL_ERROR,
} from '../types';

import api from '../../../configs/api';
import graphqlClient from '../../../configs/graphqlClient';

export const payrollCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYROLL_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payroll`,
      {
        ...payload,
      },
    );
    dispatch({ type: PAYROLL_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollAll = ({ name = '', size = 10, page = 1 }) => async (
  dispatch,
) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payroll?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PAYROLL_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollAllQuery = ({ query }) => async (dispatch) => {
  try {
    const queryResult = await graphqlClient.request(query);
    const data = queryResult?.findPayrolls;
    //  console.log('Query Data', queryResult);
    if (!data) {
      dispatch({ type: PAYROLL_ERROR });
    }

    dispatch({ type: PAYROLL_ALL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payroll/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PAYROLL_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollStateSet = (data) => async (dispatch) => {
  dispatch({ type: PAYROLL_ALL, payload: data });
};

export const payrollStateOneSet = (data) => async (dispatch) => {
  dispatch({ type: PAYROLL_GET, payload: data });
};

export const payrollPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYROLL_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/payroll/${id}`,
      payload,
    );
    dispatch({ type: PAYROLL_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYROLL_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/payroll/${id}`,
    );
    dispatch({ type: PAYROLL_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYROLL_ERROR });
    throw new Error(error);
  }
};

export const payrollReset = () => async (dispatch) => {
  dispatch({ type: PAYROLL_LOADING });
};

export const payrollError = () => async (dispatch) => {
  dispatch({ type: PAYROLL_ERROR });
};
